export default __webpack_public_path__ + "static/media/pg-2.462cabe2.jpg";